import { mutations } from "@/constants/state";
import { reject } from "lodash";

export default {
  [mutations.SHIFT_REQUESTS_FETCH_PENDING_MUTATION]: (state, payload) => {
    state.pendingShiftRequests = payload;
  },
  [mutations.SHIFT_REQUESTS_FETCH_HISTORY_MUTATION]: (state, payload) => {
    state.shiftRequestsHistory = payload;
  },
  [mutations.SHIFT_REQUESTS_REMOVE_REQUEST_MUTATION]: (state, payload) => {
    state.pendingShiftRequests = reject(state.pendingShiftRequests, {
      id: payload,
    });
  },
};
